import dynamic from 'next/dynamic';
// import Script from 'next/script';
// import { useEffect } from 'react';
import css from './index.module.scss';
import A from './components/A';

const PageConPc = dynamic(() => import('@/components/productSmart/blade/treaser/indexDynamic'), {
    ssr: true,
});

export default function BladeTreaserPC() {
    // useEffect(() => {
    //     // https://ecoflow.feishu.cn/docx/SPh2dIM1SoGm36xgSlvctzhEnth 亚马逊DSP广告代码安装需求
    //     (function (e, s, t) {
    //         t = t || {};
    //         t.id = e;
    //         const versaTagObj = {
    //             $: [],
    //             onready: function (e: never) {
    //                 this.$.push(e);
    //             },
    //         };
    //         const n: any = s.getElementsByTagName('script')[0];
    //         const r: any = s.createElement('script');
    //         r.options = t;
    //         r.async = !0;
    //         r.src = `https://secure-ds.serving-sys.com/SemiCachedScripts/ebOneTag.js?id=${e}`;
    //         r.options = t;
    //         n.parentNode.insertBefore(r, n);
    //     })('1073749300', document, { dataLayer: 'SizmekDataLayer' });
    // }, []);

    return (
        <div className={`blade-treaser-pc ${css.bladeTreaserPC}`}>
            <A />
            <PageConPc />
            <style jsx global>
                {`
                    .product_naver {
                        display: none;
                    }
                `}
            </style>
        </div>
    );
}
